@if (tableConfig) {
    <generic-list-manager [config]="tableConfig"></generic-list-manager>
}
